import { ChangeDetectorRef, Component, HostListener, OnInit, TemplateRef, ViewChild,ViewContainerRef } from '@angular/core';
import { DataService } from '../data.service';
import { HttpClient } from '@angular/common/http';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, fromEvent, Subscription, take } from 'rxjs';
import { IonModal, ModalController } from '@ionic/angular';
import { TanarComponent } from '../components/tanar/tanar.component';
import { TanteremComponent } from '../components/tanterem/tanterem.component';
import { TantargyComponent } from '../components/tantargy/tantargy.component';
import { OsztalyComponent } from '../components/osztaly/osztaly.component';

@Component({
  selector: 'app-orarend',
  templateUrl: './orarend.component.html',
  styleUrls: ['./orarend.component.scss'],
})
export class OrarendComponent  implements OnInit {
  correctCards: number = 0;
  success: boolean = false;
  cards = []; // Cards to drag
  slots = []; // Slots to drop into
  isSlotFilled: boolean[][] = []; // Track which slots are filled
  cardInSlot = []; // Store the card in the slot

  allomany=[];
  orarend=[];
  csengetes=[];

  /** 08:15:00 → 08:15 – a fejlécben a másodperc csak zajt vinne. */
  ido(ertek: any): string {
    return String(ertek || '').slice(0, 5);
  }
  osztaly=[];
  ttf=[];
  filled=[];
  elhasznalt=[];
  sajatIntezmeny;
  mostdrag

  title = 'context-menu';
  isDisplayContextMenu: boolean;
  rightClickMenuItems: Array<any> = [];
  rightClickMenuPositionX: number;
  rightClickMenuPositionY: number;
  protected readonly JSON = JSON;

  @ViewChild('userMenu') userMenu: TemplateRef<any>;
  overlayRef: OverlayRef | null;
  sub: Subscription;
  @ViewChild(IonModal) modal: IonModal;
  kivalasztottora
  nezet=1
  het=0
  napok=["Hétfő","Kedd","Szerda","Csütörtök","Péntek","Szombat","Vasárnap"]
  hetek=["A","B","C","D","E","F","G"]
  
  constructor(private modalCtrl: ModalController,public viewContainerRef: ViewContainerRef,public overlay: Overlay,private http: HttpClient,private ref:ChangeDetectorRef, private data: DataService) { }

  ngOnInit() {
    this.init();
  }
  
  async init() {
    this.isSlotFilled = [];
    this.cardInSlot = [];
    this.ttf = [];
    this.slots=[];
    this.cards=[];
    this.filled=[];
    this.elhasznalt=[];
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"));
    this.allomany = await this.data.getAllomany(this.sajatIntezmeny.intezmenyId).toPromise();
    this.allomany.forEach(a=>{
      this.allomany[a.adid]=a
      this.allomany[a.adid].intezmenyadatok = JSON.parse(this.allomany[a.adid].intezmenyadatok)[0]
    })
    
    // A tanév NEM lehet beégetve: az osztályok, a csengetési rend és a
    // tantárgyfelosztás mind tanévhez kötött. A "2024" miatt üresen jött vissza
    // mindhárom (a csengetési rend pl. csak 2025-re létezik), így a rács sem épült fel.
    const ev = String((await this.data.getMunkatanev())
      || this.sajatIntezmeny?.aktualistanev
      || new Date().getFullYear());

    this.osztaly=await this.data.getOsztaly(ev,this.sajatIntezmeny.intezmenyId).toPromise();
    this.osztaly.forEach(o=>{
      this.isSlotFilled[o.id]=new Array(this.slots.length).fill(false);
      this.cardInSlot[o.id]=new Array(this.slots.length).fill('');
    })
    this.csengetes = await this.data.getCsengetes(ev,this.sajatIntezmeny.intezmenyId).toPromise();
    for(let i=0;i<this.csengetes.length*5;i++){
      this.slots.push(i)
    }
    let ttf = await this.data.getTtf(ev,this.sajatIntezmeny.intezmenyId).toPromise();
    ttf.forEach(t=>{
      if(t.ttfel=="[null]"){ 
      }else if(t.ttfel!="[null]"){ 
        t.ttfel = JSON.parse(t.ttfel);
        for(let i = 0; i<t.ttfel.length; i++){
          //for(let j = 0; j<t.db; j++){
          this.ttf.push(
            {
              id:t.id,
              ttfelid:t.ttfel[i].id,
              tantargy:t.tantargy,
              db:t.ttfel[i].db,
              //hanyadik:j+1,
              evfolyam:JSON.parse(t.evfolyam),
              nev:t.nev,
              rovid:t.rovid,
              szin:t.szin,
              ttfel:t.ttfel[i],
              csoport:i,
              bontas: t.ttfel.length>1 ? 1:0,
              orarend: t.orarend,
              munkatars: t.munkatars
            }
          )
        //}
        }
      }
    })

    
    
    this.orarend = await this.data.getOrarend("2024",this.sajatIntezmeny.intezmenyId).toPromise();
    this.orarend.forEach(o=>{
      
      this.isSlotFilled[o.osztalyid][o.ora+(o.nap*this.csengetes.length)] = true
      this.cardInSlot[o.osztalyid][o.ora+(o.nap*this.csengetes.length)] = this.ttf.filter(f=>f.orarend == o.id)[0];
      this.filled.push(this.ttf.filter(f=>f.orarend == o.id)[0])
      this.filled[this.filled.length-1].o = o;
      if(isNaN(this.elhasznalt[this.ttf.filter(f=>f.orarend == o.id)[0].munkatars+"-"+this.ttf.filter(f=>f.orarend == o.id)[0].evfolyam.id+"-"+this.ttf.filter(f=>f.orarend == o.id)[0].tantargy])) 
        this.elhasznalt[this.ttf.filter(f=>f.orarend == o.id)[0].munkatars+"-"+this.ttf.filter(f=>f.orarend == o.id)[0].evfolyam.id+"-"+this.ttf.filter(f=>f.orarend == o.id)[0].tantargy]=0;
      this.elhasznalt[this.ttf.filter(f=>f.orarend == o.id)[0].munkatars+"-"+this.ttf.filter(f=>f.orarend == o.id)[0].evfolyam.id+"-"+this.ttf.filter(f=>f.orarend == o.id)[0].tantargy]++;
      
      
      this.cardInSlot[o.osztalyid][o.ora+(o.nap*this.csengetes.length)].orarend = o;
      
    })
    //console.log(this.elhasznalt)
    // Initialize the cards and slots
    this.cards = this.ttf.filter(a => !this.elhasznalt[a.munkatars+"-"+a.evfolyam.id+"-"+a.tantargy] || this.elhasznalt[a.munkatars+"-"+a.evfolyam.id+"-"+a.tantargy]==0 || this.elhasznalt[a.munkatars+"-"+a.evfolyam.id+"-"+a.tantargy]!=a.db).filter((value, index, self) =>
      index === self.findIndex((t) => (
        t.ttfelid === value.ttfelid
      ))
    ); 
    this.cards.forEach(cd=>{
      this.filled.forEach(f=>{
        if(cd.id == f.id && cd.munkatars == f.munkatars && cd.db>0) cd.db-=f.o.hossz;
      })
    })
    this.cards = this.cards.filter(a=> a.db != 0);

    //!this.filled.map(b=>b.orarend).includes(a.orarend) || 
    //['A', 'B', 'C', 'D', 'E'];
    
    //this.slots = ['1', '2', '3', '4', '5']; // Adjust the slots to match cards

    // Reset slot statuses
    //this.isSlotFilled = new Array(this.slots.length).fill(false);
    //this.cardInSlot = new Array(this.slots.length).fill('');

    //this.shuffle(this.cards);
  }

  shuffle(array: string[]) {
    let currentIndex = array.length, randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex !== 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }

    return array;
  }

  onDragStart(event: DragEvent, card: string) {
    this.mostdrag=card
    event.dataTransfer?.setData('json', JSON.stringify(card));
  }

  allowDrop(event: DragEvent,filled,iod,j,i) {
    for(let k=0;k<this.osztaly.length;k++) this.mouseLeave(k,i)
    this.mouseEnter(j,i)
    if(!filled && iod == this.mostdrag.evfolyam.id) 
    event.preventDefault();
  }

  onDrop(event: DragEvent, ora: string, index: number, oid) {

    event.preventDefault();
    const card = JSON.parse(event.dataTransfer?.getData('json'));
    console.log(card)
    //console.log(Math.floor(index/this.csengetes.length*10).toString()[0])
    if (card && !this.isSlotFilled[oid][index]) {
      
      /*this.cards.forEach(c=>{
        if(card.id == c.id && card.munkatars == c.munkatars && c.db>0) c.db--;
        else if(card.id == c.id && card.munkatars == c.munkatars && c.db==0) this.cards = this.cards.filter(cd => cd.id !== card.id && cd.munkatars !== card.munkatars);
      })*/
      
      if(card.orarend?.hossz) card.orarend.hossz=1
      
      this.isSlotFilled[oid][index] = true; // Mark slot as filled
      this.cardInSlot[oid][index] = card; // Store card in slot
      let nap, ora, hossz:number
      let id
      if(Math.floor(index/this.csengetes.length*10).toString().length == 1){
        nap = 0
        ora = Math.floor(index/this.csengetes.length*10).toString()
        }else{
          nap = Math.floor(index/this.csengetes.length*10).toString()[0];
          ora = Math.floor(index/this.csengetes.length*10).toString()[1];
        }
        hossz = 1;

        let rh = 1 //(<HTMLTableCellElement>document.getElementById(oid+(index-1))).colSpan ?? 1;//this.cardInSlot[oid][index]?.ohossz ?? card.orarend?.hossz ?? 1
      for(let k=1; k<parseInt(ora);k++){
        if((<HTMLTableCellElement>document.getElementById(oid+(index-k)))?.colSpan == null){
          //console.log("nincs")
          rh++;
        }
      }
      // Remove the card from the pile to indicate it's been placed
      //this.cards = this.cards.filter(c => c.ttfelid !== card.ttfelid);
      console.log(this.cardInSlot[oid][index-rh]?.orarend?.ora)
      console.log(rh)
      console.log(ora)
   
      if(parseInt(ora)-parseInt(this.cardInSlot[oid][index-rh]?.orarend?.ora)>0 && this.isSlotFilled[oid][index-rh] && this.cardInSlot[oid][index-rh].tantargy == card.tantargy && card.ttfel.munkatars == this.cardInSlot[oid][index-rh].ttfel.munkatars){
        ora = ora-rh;
        hossz = rh+1;
        id = "'"+this.cardInSlot[oid][index-rh].orarend.id+"'"
      }else if(parseInt(this.cardInSlot[oid][index+1]?.orarend?.ora)-parseInt(ora)>0 && this.isSlotFilled[oid][index+1] && this.cardInSlot[oid][index+1].tantargy == card.tantargy && card.ttfel.munkatars == this.cardInSlot[oid][index+1].ttfel.munkatars){
        ora = parseInt(ora);
        hossz = this.cardInSlot[oid][index+1]?.orarend?.hossz+1;
        id = "'"+this.cardInSlot[oid][index+1].orarend.id+"'"
      }else{
        id = 'uuid()';
      }
      const body = {
        id:id,
        intezmeny:this.sajatIntezmeny.intezmenyId,
        ev:2024,
        het:'A',
        ttf:card.ttfelid,
        nap:nap,
        ora:ora,
        hossz:hossz,
        munkatars:card.munkatars
      };
      this.http
      .post(
        '/api/orarend',body,
        /*{
          //headers: headers,
        }*/
      )
      .subscribe({
        next: (response:any) => {
          if(this.cardInSlot[oid][index-rh]?.orarend){ 
            //this.cardInSlot[oid][index-rh].orarend.hossz = hossz;
            //this.cardInSlot[oid][index-rh].orarend.ora = ora;
          }
          this.init();
          //console.log(response)
  }
})


    }else console.log("boo")
  }

  mouseEnter(j,i){
    document.getElementById("j"+j).style.background="yellow"
    document.getElementById("i"+i).style.background="yellow"
  }
  mouseLeave(j,i){
    document.getElementById("j"+j).style.background="unset"
    document.getElementById("i"+i).style.background="unset"
  }

  cardClass(i){
    if(i>1) return " tobb"
    return ""
  }

  utolsoOra(m,i){
    if(Number.isInteger(i/m)) return "utolso"
    return ""
  }

  // TypeScript Component Logic
shouldRenderCell(osztalyId: number, slotIndex: number): boolean {
  /*if (!this.isSlotFilled[osztalyId][slotIndex]) {
    return true; // Render empty slot
  }*/

  // Check if the cell at the current index is already covered by a previous cell's colspan
  for (let i = 0; i < slotIndex; i++) {
    if (this.cardInSlot[osztalyId][i]?.orarend) {
      const colspan = this.cardInSlot[osztalyId][i]['orarend'].hossz;
      if (i + colspan > slotIndex) {
        return false; // Current index is covered by a previous colspan
      }
    }
  }
  return true; // Render normally if not covered
}


ttModal(ok,id,i){
  if(!ok) return
  this.kivalasztottora = this.cardInSlot[id][i]
  this.modal.present();
}
onWillDismiss(e){

}
confirm() {
  //this.loader.present();
  //this.showLoading('Mentés...');
  this.modal.dismiss(null, 'confirm');
}
cancel() {
  this.modal.dismiss(null, 'cancel');
}
validateForm() {
  return false;
}
delOrarend(){
  
}


whatIsMyBg(id,i){
  if(this.isSlotFilled[id][i] && this.cardInSlot[id][i]?.szin){
    if(this.cardInSlot[id][i]?.orarend?.locked==1){
      return `repeating-linear-gradient(-55deg, ${this.cardInSlot[id][i]?.szin}, ${this.cardInSlot[id][i]?.szin} 10px, var(--ion-color-medium-shade) 10px, var(--ion-color-medium-shade) 20px) !important`
    }else{
      return this.cardInSlot[id][i]?.szin;
    }
  }else if(this.isSlotFilled[id][i] && !this.cardInSlot[id][i]?.szin){
    if(this.cardInSlot[id][i]?.orarend?.locked==1)
      return 'repeating-linear-gradient(-55deg, #666, #666 10px, var(--ion-color-medium-shade) 10px, var(--ion-color-medium-shade) 20px) !important'
      else
    return '#666'
  }else {
    return '#fff'
  }
 //return this.isSlotFilled[id][i] ? this.cardInSlot[id][i]?.szin ? this.cardInSlot[id][i]?.szin : '#666' : '#fff'
}

async openComponent(comp){
  /*if(comp == "tanar") comp = TanarComponent
  if(comp == "tanterem") comp = TanteremComponent
  if(comp == "tantargy") comp = TantargyComponent
  if(comp == "osztaly") comp = OsztalyComponent*/
  
  const modal = await this.modalCtrl.create({
    component: OsztalyComponent,
    cssClass: 'modalom',
    componentProps:{
      compMod: comp
    }
  });
  modal.present();

  const { data, role } = await modal.onWillDismiss();

  if (role === 'confirm') {
    //this.name = data;
  }
}


open({ x, y }: MouseEvent, user) {
  this.close();
  const positionStrategy = this.overlay.position()
    .flexibleConnectedTo({ x, y })
    .withPositions([
      {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top',
      }
    ]);

  this.overlayRef = this.overlay.create({
    positionStrategy,
    scrollStrategy: this.overlay.scrollStrategies.close()
  });

  this.overlayRef.attach(new TemplatePortal(this.userMenu, this.viewContainerRef, {
    $implicit: user
  }));

  this.sub = fromEvent<MouseEvent>(document, 'click')
    .pipe(
      filter(event => {
        const clickTarget = event.target as HTMLElement;
        return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
      }),
      take(1)
    ).subscribe(() => this.close())

}

delete (user) {
  // delete user
  this.close();
}

addRecord(user){
  alert("Add Record Test");
  this.close();

}

editRecord(user){
  let data = JSON.stringify(user);
  alert("Edit Record Test" + data);
  this.close();
}

variableInfo(user){
  alert("Variable Info Record Test");
  this.close();

}



close() {
  this.sub && this.sub.unsubscribe();
  if (this.overlayRef) {
    this.overlayRef.dispose();
    this.overlayRef = null;
  }
}




}
